import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import EventsTypesListView from "./events_types-list.html";
import EventsTypesEditView from "./events_types-edit.html";


angular.module("events_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('events_types', {
                url: "/events_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('events_types.list', {
                url: "/list",
                controller: "EventsTypesListCtrl",
                template: EventsTypesListView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })             
            .state('events_types.edit', {
                url: "/edit/:id",
                controller: "EventsTypesEditCtrl",
                template: EventsTypesEditView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })
    }])
;